import React from 'react'
import { PropTypes } from 'prop-types'
import logo from '../../../images/PinStar-15PX.png'

const SeasonHeader = ({ seasonyears }) => {
   return(
      <span style={{ fontWeight: '600', fontSize: '14px' }}>
        <img src={logo} style={{ maxWidth:'30px', marginTop:'-3px' }} />
         &nbsp;{seasonyears}&nbsp;&nbsp;Junior Gold Season
     </span>
   )
}
SeasonHeader.propTypes = {
    seasonyears: PropTypes.string
}
export default SeasonHeader


// WEBPACK FOOTER //
// ./src/containers/season/components/SeasonHeader.js